import { Injectable } from '@angular/core';
import { ReportsService as ApiReportsService } from '@ducat-pro-wallets/swag-wallet';

import { createApi } from '../utils';

@Injectable({
    providedIn: 'root',
})
export class ReportsService extends createApi(ApiReportsService) {}
